module.exports = __webpack_public_path__ + "img/CDNX-logo_small_dark.32cf96.svg";